/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';

import { TextFragment } from '../model/textFragment';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TextFragmentsService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Return the fragments
     * 
     * @param app The app
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllFragments(app: 'IOS' | 'Web' | 'All', observe?: 'body', reportProgress?: boolean): Observable<TextFragment>;
    public getAllFragments(app: 'IOS' | 'Web' | 'All', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TextFragment>>;
    public getAllFragments(app: 'IOS' | 'Web' | 'All', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TextFragment>>;
    public getAllFragments(app: 'IOS' | 'Web' | 'All', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (app === null || app === undefined) {
            throw new Error('Required parameter app was null or undefined when calling getAllFragments.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TextFragment>(`${this.getBasePath()}/api/v1/text-fragments/${encodeURIComponent(String(app))}`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return a single fragment
     * 
     * @param app The app
     * @param location The location
     * @param label The label
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFragment(app: 'IOS' | 'Web' | 'All', location: string, label: string, observe?: 'body', reportProgress?: boolean): Observable<TextFragment>;
    public getFragment(app: 'IOS' | 'Web' | 'All', location: string, label: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TextFragment>>;
    public getFragment(app: 'IOS' | 'Web' | 'All', location: string, label: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TextFragment>>;
    public getFragment(app: 'IOS' | 'Web' | 'All', location: string, label: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (app === null || app === undefined) {
            throw new Error('Required parameter app was null or undefined when calling getFragment.');
        }

        if (location === null || location === undefined) {
            throw new Error('Required parameter location was null or undefined when calling getFragment.');
        }

        if (label === null || label === undefined) {
            throw new Error('Required parameter label was null or undefined when calling getFragment.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TextFragment>(`${this.getBasePath()}/api/v1/text-fragments/${encodeURIComponent(String(app))}/${encodeURIComponent(String(location))}/${encodeURIComponent(String(label))}`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
